import { useYearParam } from '@/hooks/useYearParam';
import { useSearchParams } from 'react-router-dom';

/** Navbar'dagi tanlovlar: yil, hudud, tuman va ekin turi.
 *  Sug'urta sahifasidagi barcha so'rovlar shu qiymatlardan foydalanadi. */
export const useInsuranceFilters = () => {
  const [searchParams] = useSearchParams();
  const year = useYearParam();

  const regionCode = searchParams.get('region') || undefined;
  const districtCode = searchParams.get('district') || undefined;
  const plantId = searchParams.get('plant_type') || undefined;

  return {
    year,
    regionCode,
    districtCode,
    plantId,
    /** Barcha filtrlarni qabul qiladigan endpointlar uchun tayyor obyekt. */
    params: {
      year,
      region_code: regionCode,
      district_code: districtCode,
      plant_id: plantId,
    },
  };
};
